import React, {useState} from "react";
import HeaderMenu from "../HeaderMenu/HeaderMenu";
import ButtonLink from "../../Buttons/ButtonLink/ButtonLink";
import QuoteProjectModal from "../../Modals/QuoteProjectModal/QuoteProjectModal";
import HeaderHamburger from "../HeaderHamburger/HeaderHamburger";

const HeaderRight = ({buttonText, buttonUrl, menuData}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleButtonClick = (e) => {
        e.preventDefault(); // Zapobiega domyślnemu przeładowaniu strony
        setIsModalOpen(true); // Otwiera modal
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Zamknięcie modala
    };

    return (
        <div className="header--inside__right">
            <HeaderMenu menuData={menuData}/>
            <ButtonLink
                classes={[
                    "btn",
                    "btn-link",
                    "btn-transparent",
                    "white",
                    "btn-header",
                    "left-to-right-animate",
                    "blue-to-white",
                ]}
                text={buttonText}
                href={buttonUrl}
                hasIcon={true}
                iconClasses={["dollar-icon"]}
                onClick={handleButtonClick}
            />
            <QuoteProjectModal isOpen={isModalOpen} onClose={handleCloseModal}/>

            <HeaderHamburger/>
        </div>
    );
};

export default HeaderRight;
